// extracted by mini-css-extract-plugin
module.exports = {"readMoreButton":"ReadMore_readMoreButton__2vFIb","readMoreTextContent":"ReadMore_readMoreTextContent__1jMpV"};